export { default } from './FloatingBox';
